// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".food-card .card-item-container{align-items:flex-start}", "",{"version":3,"sources":["webpack://./resources/js/components/organisms/FoodContainer/style.scss"],"names":[],"mappings":"AAAA,gCAAgC,sBAAsB","sourcesContent":[".food-card .card-item-container{align-items:flex-start}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
